<template>
<div class="container-base" v-loading.fullscreen.lock="fullscreenLoading" style="padding-left: 100px; padding-right: 100px;">
  <div class="" v-if="step == '0'" style="height:500px">
    <div class="page-static-inner">
      <h2>{{request_name}}さんへの推薦・紹介文作成をお願いします。</h2>
      <p>「発行ボタン」をクリックすると、ご登録のメールアドレスにワンタイムパスワードを送信します。</p>
    </div>
    <div class="text-center">
      <br/>
      <el-button id="resend_secure" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
        @click="resendSecurekey()">発行する</el-button>
    </div>
  </div>
  <div class="" v-else-if="step == '0_1'" style="height:500px">
    <div class="page-static-inner">
      <h2>{{request_name}}さんへの推薦・紹介文作成をお願いします。</h2>
    </div>
    <p style="font-size: 90%;">ワンタイムパスワード：</p>
    <div style="display: inline-block;min-width: 100%;">
      <el-input class="input-md"
                placeholder=""
                title="入力してください"
                ref="secure_key"
                v-model="secure_key"
                type="text"></el-input>
    </div>
    <div class="text-center">
      <br/>
      <el-button id="resend_secure" type="success" style="background-color:#fff;border-color:#fff;color:#e3165c"
        @click="resendSecurekey()">再送信する</el-button>
    </div>
    <div class="text-center">
      <br/>
      <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
        @click="$eventHub.$emit('login-info-secure');">認証する</el-button>
    </div>
  </div>
  <div class="" v-else-if="step == '1'">
    <div class="page-static-inner">
      <h2>{{request_name}}さんへの推薦・紹介文作成をお願いします。</h2>
      <p style="font-size: 77%;">※１回送信しても再度送信することによって内容を変更することが可能です。<br> <span style="color:red;">※</span>は必須項目です。</p>
    </div>
    <br/>
    <p style="font-size: 90%;">推薦される方のお名前：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{request_name}}
    </div>
    <br/>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>就労支援事業所または施設名：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      <el-input class="input-md"
                placeholder="例）八木　一郎"
                title="入力してください"
                ref="intro_name"
                v-model="intro_name"
                type="text"></el-input>
    </div>
    <br/>
    <p style="font-size: 90%;">あなたのメールアドレス：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{intro_email}}
    </div>
    <br/>
    <p v-if="false" style="font-size: 90%;"><span style="color:red;">※</span>導入元：</p>
    <div v-if="false" style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      <el-select v-model="alliance" 
                placeholder="選択してください">
                <el-option v-for="item in selectAlliancesOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の種類：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      <el-select v-model="handbookKind" @change="selectHandbookKind"
                placeholder="選択してください">
                <el-option v-for="item in handbookKindOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の障害種類：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      <el-select v-model="shogaiKind"
                placeholder="選択してください">
                <el-option v-for="item in shogaiKindOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select><el-input v-if="shogaiKind=='その他'" type="text" class="input-sm" v-model="shogaiKind_etc"
                placeholder="直接入力してください"></el-input>
    </div>
    <br/>
    <p v-if="shogaiKind=='その他'" style="font-size: 90%;margin-bottom:5px;">手帳の障害種類の直接入力：</p>
    <div v-if="shogaiKind=='その他'" style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
          
        </p>
        <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の等級：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      <el-select v-model="shogaiLevel"
                placeholder="選択してください">
                <el-option v-for="item in shogaiLevelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
    </div>
    <br/>

    <p style="font-size: 90%;margin-bottom:5px;"><span style="color:red;">※</span>通院の有無：</p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
          <el-radio v-model="hospitalVisit"
                    label="あり"> あり</el-radio>
          <el-radio v-model="hospitalVisit"
                    label="なし"> なし</el-radio>
        </p>
    </div>
    <br/>
    <p v-if="hospitalVisit=='あり'" style="font-size: 90%;margin-bottom:5px;">通院の頻度などの詳細：</p>
    <div v-if="hospitalVisit=='あり'" style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
          <el-input type="textarea"
            :autosize="{minRows: 3, maxRows: 8}"
            v-model="hospitalVisitDescription"
            ></el-input>
        </p>
        <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
        <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;"><span style="color:red;">※</span>得意なこと・スキル：</p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
          <el-input type="textarea"
            :autosize="{minRows: 3, maxRows: 8}"
            v-model="skillDescription"
            ></el-input>
        </p>
        <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
        <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">障がい特性：<el-button @click="$modal.show('disorderFeatureSample-dialog')" type="success">例文から追加</el-button></p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
        <modal name="disorderFeatureSample-dialog"
              :adaptive="true"
              :scrollable="true"
              height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('disorderFeatureSample-dialog');"
                      icon="el-icon-close"
                      type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in disorderFeatureStatement"
                v-on:click="disorderFeature=item.replace(/<br>/ig, '\n') + '\n';$modal.hide('disorderFeatureSample-dialog');"
                :key="index">
              <div class="title">{{ index }}</div>
              <div class="body"
                  v-html="item"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('disorderFeatureSample-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
          :autosize="{minRows: 3, maxRows: 8}"
          v-model="disorderFeature"
          ></el-input>
      </p>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">障害特性に対する自己対処：<el-button @click="$modal.show('selfDisorderFeatureSample-dialog')" type="success">例文から追加</el-button></p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
        <modal name="selfDisorderFeatureSample-dialog"
              :adaptive="true"
              :scrollable="true"
              height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('selfDisorderFeatureSample-dialog');"
                      icon="el-icon-close"
                      type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in selfDisorderFeatureStatement"
                v-on:click="selfDisorderFeature=item.replace(/<br>/ig, '\n') + '\n';$modal.hide('selfDisorderFeatureSample-dialog');"
                :key="index">
              <div class="title">{{ index }}</div>
              <div class="body"
                  v-html="item"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('selfDisorderFeatureSample-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
          :autosize="{minRows: 3, maxRows: 8}"
          v-model="selfDisorderFeature"
          ></el-input>
      </p>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">自己対処ではカバーしきれない企業側への配慮希望：<el-button @click="$modal.show('considerationDesired-dialog')" type="success">例文から追加</el-button></p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
        <modal name="considerationDesired-dialog"
              :adaptive="true"
              :scrollable="true"
              height="auto">
          <div class="v--modal-close-top">
            <el-button @click="$modal.hide('considerationDesired-dialog');"
                      icon="el-icon-close"
                      type="text"></el-button>
          </div>
          <div class="title">例文を選ぶ</div>
          <div class="description">
            <p>選択した例文が追加されます。</p>
            <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
          </div>
          <ul class="example-sentence">
            <li v-for="(item, index) in considerationDesiredStatement"
                v-on:click="considerationDesired=item.replace(/<br>/ig, '\n') + '\n';$modal.hide('considerationDesired-dialog');"
                :key="index">
              <div class="title">{{ index }}</div>
              <div class="body"
                  v-html="item"></div>
            </li>
          </ul>
          <div class="text-right">
            <el-button @click="$modal.hide('considerationDesired-dialog')">閉じる</el-button>
          </div>
        </modal>
        <el-input type="textarea"
          :autosize="{minRows: 3, maxRows: 8}"
          v-model="considerationDesired"
          ></el-input>
      </p>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">採用後の定着支援対応の有無：</p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
          <el-radio v-model="supportCenter"
                    label="あり"> あり</el-radio>
          <el-radio v-model="supportCenter"
                    label="なし"> なし</el-radio>
        </p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">備考：</p>
    <div style="display: inline-block;min-width: 100%;">
      <p style="font-size: 100%;text-align:left;">
          <el-input type="textarea"
            :autosize="{minRows: 3, maxRows: 8}"
            v-model="etc"
            ></el-input>
        </p>
        <p style="font-size: 77%;"><span style="color:red;">※実際の就労支援の中での被推薦者の仕事の熱意・具体的なエピソードなど</span></p>
        <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
        <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <div class="text-center">
      <br/>
      <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
        @click="confirmForm">入力内容を確認する</el-button>
    </div>
  </div>
  <div class="" v-else-if="step == '2'">
    <div class="page-static-inner">
      <h2>{{formatData.request_name}}さんへの推薦・紹介文作成をお願いします。</h2>
      <p style="font-size: 77%;">※１回送信しても再度送信することによって内容を変更することが可能です。<br> <span style="color:red;">※</span>は必須項目です。</p>
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>就労支援事業所または施設名：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{ intro_name }}
    </div>
    <br/>
    <p style="font-size: 90%;">あなたのメールアドレス：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{intro_email}}
    </div>
    <br/>
    <p v-if="false" style="font-size: 90%;"><span style="color:red;">※</span>導入元：</p>
    <div v-if="false" style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{ alliance }}
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の種類：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{ handbookKind }}
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の障害種類：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{ shogaiKind }}<span v-if="shogaiKind_etc">{{ "："+shogaiKind_etc }}</span>
    </div>
    <br/>
    <p style="font-size: 90%;"><span style="color:red;">※</span>手帳の等級：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{ shogaiLevel }}
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;"><span style="color:red;">※</span>通院の有無：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{ hospitalVisit }}
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">通院の頻度などの詳細：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ hospitalVisitDescription }}
      </pre>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;"><span style="color:red;">※</span>得意なこと・スキル：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ skillDescription }}
      </pre>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">障がい特性：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ disorderFeature }}
      </pre>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">障害特性に対する自己対処：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ selfDisorderFeature }}
      </pre>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">自己対処ではカバーしきれない企業側への配慮希望：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ considerationDesired }}
      </pre>
      <p style="font-size: 77%;"><span style="color:red;">※最大3000文字まで、入力できます。</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">採用後の定着支援対応の有無：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ supportCenter }}
      </pre>
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">備考：</p>
    <div style="display: inline-block;min-width: 100%;">
      <pre>{{ etc }}
      </pre>
      <p style="font-size: 77%;"><span style="color:red;">※実際の就労支援の中での被推薦者の仕事の熱意・具体的なエピソードなど</span></p>
      <p style="font-size: 77%;"><span style="color:red;">※個人を特定できる情報の記載をしないでください。</span></p>
    </div>
    <br/>
    <div style="display: inline-block;min-width: 100%;">
      <p>下記をご確認いただき、事実と相違がない場合はチェックボックスをクリックして推薦内容を送信ください。
      </p>
      <p style="font-size: 77%;"><el-checkbox v-model="isAgree1" style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
                        </el-checkbox>　被推薦者本人から推薦・紹介文依頼を受けている</p>
      <p style="font-size: 77%;"><el-checkbox v-model="isAgree2" style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
                        </el-checkbox>　被推薦者が履歴書及び推薦・紹介文情報を元に障害者雇用企業からオファーを受けられることを理解している</p>
      <p style="font-size: 77%;"><el-checkbox v-model="isAgree3" style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
                        </el-checkbox>　推薦・紹介文に被推薦者の個人を特定できる情報(被推薦者の氏名・住所・電話番号など)を入力していない</p>
    </div>
    <br/>
    <div class="text-center">
      <br/>
      <el-button id="send-introduction" type="success" style="background-color:#FFF;border-color:#e3165c;color:#e3165c"
        @click="backForm">←修正する</el-button>
      <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
        @click="sendIntroduction">推薦内容を送信する</el-button>
    </div>
  </div>
  <div class="" v-else-if="step == '22'">
    <div class="page-static-inner">
      <h2>{{formatData.request_name}}さんの推薦・紹介文を入力にてください。</h2>
      <p>※１回送信しても再度送信することによって内容を変更することが可能です。</p>
    </div>
    <p style="font-size: 90%;">紹介・推薦者の姓名：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{formatData.intro_name}}
    </div>
    <br/>
    <p style="font-size: 90%;">紹介・推薦者のメールアドレス：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{formatData.intro_email}}
    </div>
    <br/>
    <p style="font-size: 90%;">紹介・推薦者の自己紹介：</p>
    <div style="display: inline-block;min-width: 100%;margin-bottom:5px;">
      {{formatData.intro_pr}}
    </div>
    <br/>
    <p style="font-size: 90%;margin-bottom:5px;">推薦・紹介文：</p>
    <div style="display: inline-block;min-width: 100%; ">
      <pre>{{formatData.introductionStatement}}</pre>
    </div>
    <br/>
    <div class="text-center">
      <br/>
      <el-button id="send-introduction" type="success" style="background-color:#FFF;border-color:#FFF;color:#e3165c"
        @click="returnEdit"><i class="el-icon-d-arrow-left"></i>編集する</el-button>
      　
      <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
        @click="$eventHub.$emit('introduction-info-send');">推薦・紹介文を送信する</el-button>
    </div>
  </div>
  <div class="" v-else-if="step == '3'">
    <div class="page-static-inner">
      <h2>{{formatData.request_name}}さんの推薦・紹介文をご入力いただき、ありがとうございました。</h2>
      <p>※１回送信しても再度送信することによって内容を変更することが可能です。</p>
    </div>
    <br/>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<script>
import LocalDataMixin from '@/mixins/local-data-mixin'
export default {
  props: {
    secureId: {
      type: String
    },
    secureKey: {
      type: String
    }
  },
  mixins: [LocalDataMixin],
  data: function () {
    return {
      saveName: 'introduction',
      qr_image: '',
      createDate: null,
      intro_name:'',
      intro_email:'',
      request_name:'',
      request_email:'',
      introductionStatement:'',
      intro_pr:'',
      fullscreenLoading:false,
      secure_key:'',
      step:'0',
      disorderFeature:'',
      selfDisorderFeature:'',
      considerationDesired:'',
      handbookKind:'',
      alliance:'',
      shogaiKind_etc:'',
      selectAlliancesOptions: [
        {value:'障がい福祉イノベーション', label:'障がい福祉イノベーション'},
        {value:'広告やメディア', label:'広告やメディア'},
        {value:'障がい者から依頼', label:'障がい者から依頼'},
        {value:'その他', label:'その他'},
      ],
      handbookKindOptions: [
        {value:'身体障害者手帳', label:'身体障害者手帳'},
        {value:'療育手帳', label:'療育手帳'},
        {value:'精神障害者保健福祉手帳', label:'精神障害者保健福祉手帳'},
      ],
      disorderFeatureStatement: {
        "特性①":"急ぎの作業の際にケアレスミスが起きやすい",
        "特性②":"過集中傾向があり、話しかけられても気づかない時がある。",
        "特性③":"マルチタスクが苦手"
      },
      selfDisorderFeatureStatement: {
        "自己対応①":"Wチェックの徹底を行い、納品時に第三者のチェックをお願いする",
        "自己対応②":"適度な小休憩で過集中を防ぐ",
        "自己対応③":"作業開始前にタスク整理を行い、各作業を時間単位で区切り、マルチタスクに対応する"
      },
      considerationDesiredStatement: {
        "配慮①":"通院配慮：月に1度、第三火曜日に通院のため、午前休を頂ければ幸いです。",
        "配慮②":"過度な残業：残業は月に約5時間以内をお願いできればと思います。",
        "配慮③":"相談環境：業務で悩んだ際に相談しやすい環境があれば幸いです。"
      },
      shogaiKind:'',
      shogaiKindOptions: [],
      shogaiKindOptionTemps: {
        first: [
            {value:'視覚障害', label:'視覚障害'},
            {value:'聴覚または平衡機能の障害', label:'聴覚または平衡機能の障害'},
            {value:'音声機能', label:'音声機能'},
            {value:'言語機能またはそしゃく機能の障害', label:'言語機能またはそしゃく機能の障害'},
            {value:'肢体不自由（車椅子あり）', label:'肢体不自由（車椅子あり）'},
            {value:'肢体不自由（車椅子なし）', label:'肢体不自由（車椅子なし）'},
            {value:'心臓機能の障害', label:'心臓機能の障害'},
            {value:'じん臓機能の障害', label:'じん臓機能の障害'},
            {value:'呼吸器機能の障害', label:'呼吸器機能の障害'},
            {value:'ぼうこうまたは直腸の機能の障害', label:'ぼうこうまたは直腸の機能の障害'},
            {value:'小腸の機能の障害', label:'小腸の機能の障害'},
            {value:'ヒト免疫不全ウイルスによる免疫の機能の障害', label:'ヒト免疫不全ウイルスによる免疫の機能の障害'},
            {value:'肝臓の機能の障害', label:'肝臓の機能の障害'},
            {value:'その他', label:'その他'},
        ],
        second: [
            {value:'知的障害', label:'知的障害'},
            {value:'その他', label:'その他'},
        ],
        third: [
            {value:'統合失調症', label:'統合失調症'},
            {value:'うつ病、双極性障害（躁うつ病）などの気分障害', label:'うつ病、双極性障害（躁うつ病）などの気分障害'},
            {value:'非定型精神病', label:'非定型精神病'},
            {value:'てんかん', label:'てんかん'},
            {value:'中毒精神病', label:'中毒精神病'},
            {value:'高次脳機能障害', label:'高次脳機能障害'},
            {value:'発達障害', label:'発達障害'},
            {value:'その他の精神疾患など', label:'その他の精神疾患など'},
            {value:'その他', label:'その他'},
        ]
      },
      shogaiLevel:'',
      shogaiLevelOptions: [],
      shogaiLevelOptionTemps: {
        first: [
          {value:'1級', label:'1級'},
          {value:'2級', label:'2級'},
          {value:'3級', label:'3級'},
          {value:'4級', label:'4級'},
          {value:'5級', label:'5級'},
          {value:'6級', label:'6級'},
          {value:'7級', label:'7級'},
          {value:'手帳取得中', label:'手帳取得中'},
        ],
        second: [
          {value:'最重度（A判定）', label:'最重度（A判定）'},
          {value:'重度（A判定）', label:'重度（A判定）'},
          {value:'中度（B判定）', label:'中度（B判定）'},
          {value:'軽度（B判定）', label:'軽度（B判定）'},
          {value:'それ以外（B判定）', label:'それ以外（B判定）'},
          {value:'手帳取得中', label:'手帳取得中'},
        ],
        third: [
          {value:'1級', label:'1級'},
          {value:'2級', label:'2級'},
          {value:'3級', label:'3級'},
          {value:'手帳取得中', label:'手帳取得中'},
        ]
      },
      skillDescription:'',
      hospitalVisit:'あり',
      hospitalVisitDescription:'',
      supportCenter:'あり',
      etc:'',
      isAgree1:false,
      isAgree2:false,
      isAgree3:false,
      exampleSentences: {
        // 志望動機
        introduction_statement: {
          '教授用': '◯◯◯◯氏は、私の◯◯学部◯◯学科でのゼミ内で\n◯◯を修めた学生です。在学中は◯◯を専門に研究し\n◯◯の点で非常に優れている学生だと感じております。\n\n◯◯で◯◯な性格でもあり、貴社に採用いただけましたら、\n必ずや活躍してくれるものと信じております。\nご高配を賜りますようお願い申し上げます。',
          'バイト先の店長': '◯◯◯◯氏は、私の◯◯社・◯◯店舗で◯年\n◯◯の業務を行った学生です。業務中は◯◯の活動から\n◯◯の点で非常に優れている学生だと感じております。\n\n◯◯で◯◯な性格でもあり、貴社に採用いただけましたら、\n必ずや活躍してくれるものと信じております。\nご高配を賜りますようお願い申し上げます。',
          '院卒': '〇〇〇〇君は、私が指導を務めている〇〇学部の〇〇学科にて優秀な成績を収めている学生です。\n\n大学院でも積極的に研究などに打ち込んでおり、在学中は主に〇〇を専門的に研究を行っています。また学業だけでなく〇〇部でも部長として活躍をしており、学園祭などでは率先して部の紹介を行っております。部員たちからの評価も高く、指導をしている私としても安心して任せていくことができます。非常に勝ち気な性格を持っており、明るさや協調性については問題無いと判断しております。\n\nそして努力家でもありますので、御社に採用していただくことができましたら、担当する事業でも人間性を十分に発揮していくことができるでしょう。\n\n今後ともご高配を賜りますよう、よろしくお願い申し上げます。\n',
          '高校の恩師・部活の恩師': '〇〇〇〇君は、私がかつて○○学校で指導を務めていた○○部の優秀な学生です。\n\n在学中は、学業への取り組みも熱心で、〇〇部でも部長としても活躍をしており、\n○○（大会・コンクール）などでは率先して部をまとめあげ○○を獲得した実績があります。\n部員たちからの評価も高く、指導をしている私としても安心して任せていくことができます。\n非常に勝ち気な性格を持っており、明るさや協調性については問題無いと判断しております。\n\nそして努力家でもありますので、御社に採用していただくことができましたら、担当する事業でも人間性を十分に発揮していくことができるでしょう。\n\n今後ともご高配を賜りますよう、よろしくお願い申し上げます。'
        }
      }
    }
  },
  computed: {},
  methods: {
    selectHandbookKind: function() {
      if (this.handbookKind == '身体障害者手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.first
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.first
      }
      if (this.handbookKind == '療育手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.second
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.second
      }
      if (this.handbookKind == '精神障害者保健福祉手帳') {
        this.shogaiKindOptions = this.shogaiKindOptionTemps.third
        this.shogaiLevelOptions = this.shogaiLevelOptionTemps.third
      }
      this.shogaiKind = ''
      this.shogaiLevel = ''
    },
    introductionStatementX: function () {
      return this.formatData.introductionStatement.replace(/<br>/ig, '\n')
    },
    updateFormatData: function (data) {
      console.error("updateFormatData")
      this.formatData = data
      console.error(data)
    },
    loginInfoConfirm: function () {
      this.step = '2'
    },
    confirmForm: function () {
      const app = this

      if (!this.intro_name) {
        app.$message({
          message: 'あなたのお名前を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.handbookKind) {
        app.$message({
          message: '手帳の種類を選択してください',
          type: 'error'
        })
        return false
      } 
      if (!this.shogaiKind) {
        app.$message({
          message: '手帳の障害種類を選択してください',
          type: 'error'
        })
        return false
      } 
      if (!this.shogaiLevel) {
        app.$message({
          message: '手帳の等級を選択してください',
          type: 'error'
        })
        return false
      } 
      if (!this.skillDescription) {
        app.$message({
          message: '得意なこと・スキルを入力してください',
          type: 'error'
        })
        return false
      } 

      this.step = '2'
    },
    backForm: function () {
      this.step = '1'
    },
    sendIntroduction: function () {
      if (!this.isAgree1 || !this.isAgree2 || !this.isAgree3) {
        this.$message({
          duration: 0,
          showClose: true,
          message: '情報提供にあたり、同意してください',
          type: 'error'
        })
        return
      }
      const app = this
      const formData = new FormData()
      formData.append('secure_id', this.secureId)
      formData.append('secure_key', this.secure_key)
      formData.append('intro_name', this.intro_name)
      formData.append('handbook_kind', this.handbookKind)
      if (this.shogaiKind == 'その他') {
        formData.append('shogai_kind', this.shogaiKind_etc)
      } else {
        formData.append('shogai_kind', this.shogaiKind)
      }
      formData.append('shogai_level', this.shogaiLevel)
      formData.append('skill_description', this.skillDescription)
      formData.append('hospital_visit', this.hospitalVisit)
      formData.append('support_center', this.supportCenter)
      formData.append('hospital_visit_description', this.hospitalVisitDescription)
      formData.append('etc', this.etc)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      
      formData.append('disorder_feature', this.disorderFeature)
      formData.append('self_disorder_feature', this.selfDisorderFeature)
      formData.append('consideration_desired', this.considerationDesired)
      formData.append('alliance', this.alliance)

      this.$axios
        .post(this.$varuna.endPoints.sendShogaiRecommend, formData, {timeout: 60000})
        .then(function (response) {
          app.step = '3'
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `推薦・紹介文の登録を成功しました`,
            type: 'info'
          })
        })
        .catch(function (error) {
          console.log(error)
          app.$message({
            duration: 0,
            showClose: true,
            message: error.response.data+'。入力内容を確認して再度ご入力ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    returnEdit: function () {
      this.step = '1'
    },
    resendSecurekey: function () {
      const app = this
      const formData = new FormData()
      formData.append('secure_id', this.secureId)
      formData.append('secure_key', this.secure_key)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('shogai_flag', '1')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.resendSecurekey, formData, {timeout: 60000})
        .then(function (response) {
          app.step = '0_1'
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `ワンタイムパスワードを送信しました`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '入力内容を確認して再度ご入力ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    loginInfoSecure: function () {
      const app = this
      const formData = new FormData()
      formData.append('secure_id', this.secureId)
      formData.append('secure_key', this.secure_key)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.secureIntroduction, formData, {timeout: 60000})
        .then(function (response) {
          app.step = '1'
          if (!app.intro_name) 
            app.intro_name = response.data.intro_name
          app.intro_email = response.data.intro_email
          
          app.request_name = response.data.request_name
          app.request_email = response.data.intro_email
          
          app.$cookies.config(60 * 60,'')
          app.$cookies.set('_YAGISH_INTROSECURE_LOGIN', app.secure_key, null, null, null)

          // app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `認証成功しました`,
            type: 'info'
          })
        })
        .catch(function (error) {
          console.log(error)
          app.$message({
            duration: 0,
            showClose: true,
            message: error.response.data+'。入力内容を確認して再度ご入力ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  watch: {
    formatData: function () {
    }
  },
  created: function () {
    console.log(this.secureId)
    console.log(this.secureKey)
    if (this.secureKey) {
      this.secure_key = this.secureKey
      this.step = '0_1'
    }
    console.log(this.step)
    var confirm_code  = this.$cookies.get('_YAGISH_INTROSECURE_LOGIN')
    if (confirm_code) {

      const app = this
      const formData = new FormData()
      formData.append('secure_id', this.secureId)
      formData.append('secure_key', confirm_code)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.secureIntroduction, formData, {timeout: 60000})
        .then(function (response) {
          app.intro_name = response.data.intro_name
          app.intro_email = response.data.intro_email
          
          app.request_name = response.data.request_name
          app.request_email = response.data.intro_email
          
          app.$cookies.config(60 * 60,'')
          app.$cookies.set('_YAGISH_INTROSECURE_LOGIN', app.secure_key, null, null, null)

        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: 'アクセスエラーです。',
            type: 'error'
          })
        })
    } else {
      const app = this
      const formData = new FormData()
      formData.append('secure_id', this.secureId)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.getRequestIntroduction, formData, {timeout: 60000})
        .then(function (response) {
          if (!app.formatData.intro_name) 
            app.intro_name = response.data.intro_name
          app.request_name = response.data.request_name
        })
        .catch(function (error) {
          app.step = '0'
        })

    }
    // this.step = '1'
  },
  mounted: function () {},
  beforeMount: function () {
    this.$eventHub.$on('introduction-info-send', this.sendIntroduction)
    this.$eventHub.$on('login-info-confirm', this.loginInfoConfirm)
    this.$eventHub.$on('login-info-secure', this.loginInfoSecure)
    this.$eventHub.$on('format-data-changed', this.updateFormatData)
  },
  destroyed: function () {
    this.$eventHub.$off('introduction-info-send', this.sendIntroduction)
    this.$eventHub.$off('login-info-confirm', this.loginInfoConfirm)
    this.$eventHub.$off('login-info-secure', this.loginInfoSecure)
    this.$eventHub.$off('format-data-changed', this.updateFormatData)
  }
}
</script>
